
import Event = createjs.Event;

export class Poker2PanelEvent extends Event {
    public static MOUSE_ON_PANEL: string = "mouseonpanel";

    public params: any[] = null;

    constructor(type: string, params: any[] = null, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);

        this.params = params;
    }
}
